export default "__VITE_ASSET__DCDG7xef__"